import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Typography, Divider, Table, notification, Popconfirm, Space, Tag } from 'antd';

import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  FilePdfOutlined,
  DollarCircleOutlined
} from "@ant-design/icons";


import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import ServiceModal from './modal';
import CalcModal from './CalcModal'

import './index.less';

const { Title } = Typography;

const langContext = 'reserved-area.service'

export default ({ }) => {
  const intl = useIntl();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { uid } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalUID, setModalUID] = useState(null);
  const [isCalcModalVisible, setCalcModalVisible] = useState(false);
  const [modalData, setCalcModalData] = useState(null);
  const [calcModalUID, setCalcModalUID] = useState(null)
  useEffect(() => {
    onLoadData()
  }, []);

  function onLoadData() {
    setLoading(true);
    _service({
      method: 'GET',
      url: '/client/service/list',
      success: (response) => {
        setData(response.json);
        console.log(response.json)
        setLoading(false);
      },
      fail: (e) => {
        setLoading(false);
        notification["error"]({
          message: 'Não foi possivel carregar os dados da tabela.',
          description: e.response.json.error,
        });
      }
    });
  }
  const onLoadTable = () => {
    onLoadData()
  }

  const showModal = () => {
    setIsModalVisible(true);
    setModalUID(null)
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onEditModal = (data) => {
    setIsModalVisible(true);
    setModalUID(data.uid);
  };

  const openCalcModal = (data) => {
    setCalcModalVisible(true);
    setCalcModalData(data);
    setCalcModalUID(data.uid)
  }

  const onCalcModalClose = () => {
    setCalcModalVisible(false)
    setModalUID(null)
  }

  function onDeleteWork(uid) {
    setLoading(true);
    _service({
      method: 'DELETE',
      url: '/client/service',
      data: { uid: uid },
      success: (response) => {
        if (response.json.result) {
          const newData = data.filter(elem => elem.uid !== uid)
          setData(newData);
          setLoading(false);
          notification["success"]({
            message: 'Serviço removido com sucesso',
          });
        }
      },
      fail: (e) => {
        setLoading(false);
        notification["error"]({
          message: 'Não foi possivel apagar o Serviço.',
          description: e.response.json.error,
        });
      }
    });
  }

  const columns = [
    {
      title: intl.formatMessage({ id: langContext + '.fields.code' }),
      dataIndex: ['service_type', 'code'],
      key: 'code',
      render: data =>
        <td data-label={intl.formatMessage({ id: langContext + '.fields.code' })}>
          {data}
        </td>
    },
    {
      title: intl.formatMessage({ id: langContext + '.fields.waste-type' }),
      dataIndex: 'waste_type',
      key: 'waste',
      render: data =>
        <td data-label={intl.formatMessage({ id: langContext + '.fields.waste-type' })}>
          {data.description[intl.locale.split('-')[0]]}
        </td>
    },
    {
      title: intl.formatMessage({ id: langContext + '.fields.service-type' }),
      dataIndex: 'service_type',
      key: 'service',
      render: data =>
        <td data-label={intl.formatMessage({ id: langContext + '.fields.service-type' })}>
          {data.description[intl.locale.split('-')[0]]}
        </td>
    },

    {
      title: intl.formatMessage({ id: langContext + '.fields.price' }) + ' (€)',
      dataIndex: 'price',
      key: 'price',
      render: data =>
        <td data-label={intl.formatMessage({ id: langContext + '.fields.price' })}>
          {data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
        </td>
    },
    {
      title: intl.formatMessage({ id: 'components.measurement-unit-select.title' }),
      dataIndex: 'measurement_unit',
      key: 'measurement_unit',
      render: data =>
        <td data-label={intl.formatMessage({ id: 'components.measurement-unit-select.title' })}>
          {data.description[intl.locale.split('-')[0]]}
        </td>
    },
    {
      title: intl.formatMessage({ id: 'reserved-area.marketplace.fields.own-transport' }),
      dataIndex: 'own_transport',
      key: 'own_transport',
      render: data =>
        <td data-label={intl.formatMessage({ id: 'reserved-area.marketplace.fields.own-transport' })}>
          {data == true ? <CheckCircleOutlined style={{ color: "#52c41a" }} /> : <CloseCircleOutlined style={{ color: "#f5222d" }} />}
        </td>
    },
    {
      title: intl.formatMessage({ id: langContext + '.fields.action' }),
      key: 'edit',
      width: '5%',
      render: data =>
        <>
          <div>
            <td data-label={intl.formatMessage({ id: langContext + '.fields.action' })}></td>
            <Space style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <Button title="Ver no Marketplace" type='primary' onClick={() => openCalcModal(data)}>
                <FormattedMessage id={`reserved-area.construction.button.see-marketplace`} />
              </Button>
              <div style={{ display: 'flex', width: '100%'}}>
                <Button
                  title="Editar"
                  className="edit-row"
                  onClick={() => onEditModal(data)}
                >
                  <FormattedMessage id={`${langContext}.button.edit`} />
                </Button>
                <Popconfirm
                  title="Tem a certeza que deseja apagar o Serviço?"
                  onConfirm={() => onDeleteWork(data.uid)}
                  okText="Sim"
                  cancelText="Não"
                >
                  <Button danger type='text' title='Apagar'><FormattedMessage id={`${langContext}.button.delete`} /></Button>
                </Popconfirm>
              </div>
            </Space>
          </div>
        </>
    }
  ];

  return (
    <div className="service">
      <div>
        <Title level={2}><FormattedMessage id={`${langContext}.title`} /></Title>
        <Button onClick={showModal} type="primary">
          <FormattedMessage id={`${langContext}.button.create`} />
        </Button>
        <Divider />
        <Table
          columns={columns}
          loading={loading}
          dataSource={data}
        />
      </div>
      {isModalVisible && <ServiceModal onClose={handleCancel} serviceUID={uid} uid={modalUID} onLoad={onLoadTable} />}
      {isCalcModalVisible && <CalcModal onClose={onCalcModalClose} serviceUID={uid} uid={calcModalUID} data={data} />}
    </div>
  );
}
